export class SimpleRegisteredEstablishmentInfo {
    ID;
    LAEName;
    LAENumber;
    constructor({id, laeName, laeNumber}) {
        this.ID = id;
        this.LAEName = laeName;
        this.LAENumber = laeNumber;
    }
}